module.exports = __webpack_public_path__ + "static/media/spike.06972f79.svg";